import React from 'react';

import Typography from '@mui/material/Typography';

import {
  matchStatus,
  matchFeedbackType,
  matchPriority,
  getFormatedDate,
} from '../../../utils/feedback';

import { DetailsContainer, DetailTitle, StatusContainer } from './styles';

export default function AdminDetails({
  status,
  name,
  type,
  priority,
  createdAt,
}) {
  let backgroundColor = '#D1D1D1';
  if (status === 'open') backgroundColor = '#FF9F09';
  if (status === 'answered') backgroundColor = '#29CC6A';

  return (
    <>
      <DetailsContainer>
        <DetailTitle>Status</DetailTitle>
        <StatusContainer sx={{ backgroundColor }}>
          {matchStatus(status)}
        </StatusContainer>
      </DetailsContainer>
      <DetailsContainer>
        <DetailTitle>Responsável</DetailTitle>
        <Typography>{name}</Typography>
      </DetailsContainer>
      <DetailsContainer>
        <DetailTitle>Tipo de feedback</DetailTitle>
        <Typography>{matchFeedbackType(type)}</Typography>
      </DetailsContainer>
      <DetailsContainer>
        <DetailTitle>Prioridade</DetailTitle>
        <Typography>{matchPriority(priority)}</Typography>
      </DetailsContainer>
      <DetailsContainer>
        <DetailTitle>Data de abertura</DetailTitle>
        <Typography>{getFormatedDate(createdAt)}</Typography>
      </DetailsContainer>
    </>
  );
}
